import {
  AfterViewInit,
  Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef,
  forwardRef, inject, input, InputSignal, PLATFORM_ID, viewChild,
} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {isPlatformBrowser, NgClass} from '@angular/common';
import {LucideAngularModule, MapPinned} from 'lucide-angular';
import {TranslatePipe} from '@ngx-translate/core';
import {GoogleMapsService} from '../../../core/services/google-maps/google-maps.service';

@Component({
  selector: 'app-places-autocomplete',
  imports: [
    FormsModule,
    LucideAngularModule,
    TranslatePipe,
    NgClass,
  ],
  templateUrl: './places-autocomplete.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PlacesAutocomplete),
      multi: true
    }
  ],
})
export class PlacesAutocomplete implements ControlValueAccessor, AfterViewInit {
  #platformId: Object = inject(PLATFORM_ID);
  #googleMapsService: GoogleMapsService = inject(GoogleMapsService);

  searchInput = viewChild('searchInput', {read: ElementRef<HTMLInputElement>});
  label: InputSignal<string> = input('');
  placeholder: InputSignal<string> = input('');

  // Style customization inputs
  containerClass: InputSignal<string> = input('');
  inputClass: InputSignal<string> = input('');
  iconClass: InputSignal<string> = input('');

  // Default classes
  readonly defaultContainerClass = 'relative';
  readonly defaultInputClass = 'w-full pl-10 pr-2 py-3.5 bg-white/20 border border-white/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-white/50 placeholder-gray-200';
  readonly defaultIconClass = 'absolute top-1/2 -translate-y-1/2 left-3';

  onChange: (value: string) => void = () => {
  };
  onTouched: () => void = () => {
  };

  onInput(): void {
    const value = this.searchInput()?.nativeElement.value;
    this.onChange(value);
    this.onTouched();
  }

  writeValue(obj: any): void {
    if (this.searchInput()?.nativeElement) {
      this.searchInput()!.nativeElement.value = obj;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(_isDisabled: boolean): void {
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.#platformId)) {
      this.#googleMapsService.loadPlacesApi().then(() => {
        const autocomplete = new google.maps.places.Autocomplete(this.searchInput()?.nativeElement, {
          types: ['geocode', 'establishment'],
          componentRestrictions: {country: 'CA'},
          fields: ['formatted_address', 'geometry', 'name']
        });
        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();
          this.searchInput()!.nativeElement.value = place.formatted_address || '';
          this.onChange(this.searchInput()!.nativeElement.value);
          this.onTouched();
        });
      });
    }
  }

  protected readonly MapPinned = MapPinned;
}

